import * as React from "react";
import { TableBody, TableCell, TableHead, TableRow, Stack, Typography, Pagination, Box } from "@mui/material";
import SearchTxtField from "../../../components/SearchTxtField";
import route from "../../../utils/Routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import StyledTableContainer from "../../../components/StyledTableContainer";
import { useState } from "react";
import { formatDateTime, formatName, formatUserType, isNotEmpty } from "../../../utils/format";
import { useAuthContext } from "../../../context/AuthContext";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import { getNotApprComEmpServ } from "../../../services/com-service";



const columns = [
  {
    id: 'empName',
    label: "Employee Name",
    align: 'left',
    minWidth: 150,
  },
  {
    id: 'empId',
    label: "Employee ID",
    align: 'left',
    minWidth: 150
  },
  {
    id: 'username',
    label: "Email ID",
    align: 'left',
    minWidth: 150,
  },
  {
    id: 'role',
    label: "Employee Role",
    align: 'left',
    minWidth: 150
  },
  {
    id: 'cAt',
    label: "Created At",
    align: 'left',
    minWidth: 150,
  },
  {
    id: 'isApproved',
    label: "Approval Status",
    align: 'left',
    minWidth: 150
  }
];




function NotApprComEmp({ aComId }) {
  const navigate = useNavigate();
  const { setLoadingScreen } = useAuthContext();
  const limit = 7
  const [searchParams, setSearchParams] = useSearchParams();
  const pgNo = parseInt(searchParams.get("pgNo") || "1");
  const querySearchWord = searchParams.get("s") || "";
  const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
  const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
  const comId = aComId


  const { isLoading, isError, error, data: empData } = useQuery([QueryKey.notApprEmp, pgNo, comId, isSrchBtnClick],
    () => getNotApprComEmpServ({ comId, limit, pageNumber: pgNo, searchWord }), {
    enabled: isNotEmpty(comId),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    keepPreviousData: true
  });



  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  async function onSearchBtnClick(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
  }

  function onSearch(e) {
    setSearchWord(e.target.value)
    setSearchParams(prev => {
      prev.set("s", encodeURIComponent(e.target.value))
      return prev
    }, { replace: true })
  }

  function handleOnClear(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchWord("");
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("s", "")
      return prev
    }, { replace: true })
  }

  const handleRowClick = (userId) => {
    navigate(`${route.aComUserProfile}/?userId=${userId}`);
  };



  const handlePageChange = async (event, value) => {
    //    setPageNumber(value);
    setSearchParams(prev => {
      prev.set("pgNo", value)
      return prev
    }, { replace: true })
  };



  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }
  return (
    <Box height={"90%"} width={"100%"} px={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1, pl: 1, pr: 3 }} width={"100%"}>
        <Stack width={"20%"} >
          <Typography sx={{ fontSize: 18, fontWeight: 500, }}>Employee List</Typography>
        </Stack>
        <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={400}>
          <SearchTxtField width={"100%"} handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick}
            placeholder="Search Emp By Name / Email / EmpId..." />
        </Stack>
        <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"20%"} >

        </Stack>
      </Stack>

      {empData && <StyledTableContainer height={"81%"} isStickyHeader={true}>
        <TableHead>
          <TableRow >
            {columns.map((column) => (
              <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(empData?.empArr || []).map((i) => {
            return (
              <React.Fragment key={i?.id}>
                <TableRow hover tabIndex={-1} onClick={() => handleRowClick(i?.userId)}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50, cursor: 'pointer' }} >
                  {columns.map((column) => {
                    const value = i[column.id];
                    switch (column.id) {
                      case "empName":
                        return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                          {formatName(i?.fName, i?.lName)}
                        </TableCell>
                      case "role":
                        return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                          {formatUserType(i?.userType)}
                        </TableCell>
                      case "isApproved":
                        return <TableCell key={column.id} align={column.align} sx={{
                          textAlign: column.align, fontSize: 13,
                          color: value === 1 ? "green" : "orange"
                        }}>
                          {formatUserType(value)}
                        </TableCell>
                      case "cAt":
                        return (
                          <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                            {formatDateTime(value)}
                          </TableCell>
                        );
                      default:
                        return (
                          <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                            {(value === null || value === "" || value === "null") ? "NA" : value}
                          </TableCell>
                        );
                    }
                  })}
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </StyledTableContainer>}
      <Stack sx={{ alignItems: "center", mt: 2 }}>
        <Pagination count={Math.ceil(empData?.totalEmpCount / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
          variant="outlined" shape="rounded" />
      </Stack>

    </Box>
  );
}


export default NotApprComEmp;